
import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import {
  VisibleCaptureProperty,
  VisibleFluorescenceCaptureProperty
} from "../../../Model/CaptureProfile";
import { Brightness } from '../../../Model/ImagerCapabilities';
import { BasicControl } from "../ImagerFeatureControls";


type BrightnessControlProps = {
  disabled: boolean;
  brightness: Brightness;
  captureProperty: VisibleCaptureProperty | VisibleFluorescenceCaptureProperty;
  onChange: (value: { brightness: number }) => void;
};

export function BrightnessControl({ disabled, brightness, captureProperty, onChange }: BrightnessControlProps) {
  if (captureProperty.brightness == null) {
    throw new Error("Capture profile brightness is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Bright Field"
      id={EOpticAndCameraFeature.Brightness}
      min={brightness.minBrightness}
      max={brightness.maxBrightness}
      value={captureProperty.brightness}
      onValueChanged={(id, value) => {
        onChange({
          brightness: value,
        });
      }}
      unit="%"
      step={0.1}
    />
  );
}
